import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const OrderSummary = ({ membershipListData }) => {
	const { t } = useTranslation('orderSummary');
	const { result } = useSelector(
		(state) => state.customerDetailsSlice.postBrowserDetails
	);

	return (
		<Box>
			<Typography variant='subtitle1' sx={{ fontWeight: 600, mb: 2 }}>
				{t('yourOrder')}
			</Typography>

			<Box
				sx={{
					p: 2,
					mb: 3
				}}
			>
				<Stack direction='row' spacing={2} alignItems='flex-start'>
					<Box
						sx={{
							width: 90,
							height: 90,
							borderRadius: '50%',
							border: '2px solid',
							borderColor: 'divider',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							overflow: 'hidden',
							flexShrink: 0,
							backgroundColor: 'white',
							boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)'
						}}
					>
						<Box
							component='img'
							src={membershipListData?.logo}
							alt={membershipListData?.name}
							sx={{
								maxWidth: '75%',
								maxHeight: '75%',
								objectFit: 'contain'
							}}
						/>
					</Box>

					<Box sx={{ flex: 1 }}>
						<Typography variant='body2' sx={{ fontWeight: 600 }}>
							{membershipListData?.name}
						</Typography>
						<Typography
							variant='caption'
							sx={{ color: 'text.secondary', lineHeight: 1.3 }}
						>
							{t('afterTrial', {
								trialDuration: result.trial_period,
								price: result.price,
								billingDuration: result.billing_duration
							})}
						</Typography>
					</Box>

					<Typography variant='body2' sx={{ fontWeight: 600 }}>
						${result.trial_price}
					</Typography>
				</Stack>
			</Box>
		</Box>
	);
};

OrderSummary.propTypes = {
	membershipListData: PropTypes.object
};

export default OrderSummary;
